import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setAuthData } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/"); return; }

    const sessionId = match[1];

    (async () => {
      try {
        const res = await axios.post(`${API}/auth/session`, { session_id: sessionId });
        if (res.data.success) {
          // Store token in localStorage for cross-domain Bearer auth
          setAuthData(res.data.user, res.data.token);
          navigate("/dashboard", { replace: true });
        } else {
          navigate("/");
        }
      } catch (e) {
        console.error("Auth callback error:", e);
        navigate("/");
      }
    })();
  }, [navigate, setAuthData]);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-10 w-10 text-amber-400 animate-spin" />
        <p className="text-slate-400 text-sm">Authenticating...</p>
      </div>
    </div>
  );
}
